import { createFileRoute } from '@tanstack/react-router'

import { ImpersonatePage } from '../../components/pages/impersonate-page.tsx'

export const Route = createFileRoute('/impersonate')({
  component: ImpersonatePage,
})
